import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import InputComponent from "../../../components/InputComponent";
import SearchSelectComponent from "../../../components/SearchSelectComponent";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Routes from "../../../helpers/Routes";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import {
  CreateAssistanceDTO,
  CreateAssistanceDTOSchema,
} from "../../../models/Assistance/CreateAssistanceDTO";
import { EquipmentDTO } from "../../../models/Equipment/EquipmentDTO";
import { ProjectDTO } from "../../../models/Project/ProjectDTO";
import { SearchByProject } from "../../../models/Project/SearchByProject";
import { AssistanceService } from "../../../services/AssistanceService";
import { ProjectService } from "../../../services/ProjectService";
import { AssistanceCheckListService } from "../../../services/AssistanceCheckListService";
import ClientEquipmentBidirecional from "../../ClientEquipmentBidirecional/ClientEquipmentBidirecional";
import SelectComponent from "../../SelectComponent";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";
import { RenderCountersInputs } from "../RenderCountersInputs";
import CheckboxComponent from "../../CheckboxComponent";
import { Parameter } from "../../../models/Parameter";


export type SelectItemsProps = {
  label: string;
  value: string;
};

export default function AssistanceCreateB() {
  const navigate = useNavigate();
  const projectService = new ProjectService();
  const assistanceService = new AssistanceService();
  const assistanceCheckListService = new AssistanceCheckListService();
  const intl = useIntl();

  const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);
  const [isSearchProjectLoading, setIsSearchProjectLoading] = useState<boolean>(false);

  const [assistance, setAssistance] = useState<AssistanceDTO>({
    date: new Date(),
  } as AssistanceDTO);

  // Separate state variables for date and time
  const [assistanceDate, setAssistanceDate] = useState<string>(Utilities.formatDateYYYYMMDD(new Date()));
  const [assistanceTime, setAssistanceTime] = useState<string>(Utilities.GetTimeFromDateTime(new Date()));

  const [project, setProject] = useState<ProjectDTO>({} as ProjectDTO);

  const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
  const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

  const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
  const [isActiveFabricationModule, setIsActiveFabricationModule] = useState<boolean>(false);
  const [isActiveProfitabilityModule, setIsActiveProfitabilityModule] = useState<boolean>(false);
  const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
  const [isActivePriorityModule, setIsActivePriorityModule] = useState<boolean>(false);
  const [isActiveErpSupportModule, setIsActiveErpSupportModule] = useState<boolean>(false);

  const [selectedAssistancePriority, setSelectedAssistancePriority] = useState<string>("");
  const [assistancePriority, setAssistancePriority] = useState<SelectItemsProps[]>([]);

  // módulo contadores
  const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);
  const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>({
    counter1: 0,
    counter2: 0,
    counter3: 0,
  } as TimeHistoryDTO);


  // props para novo componente
  const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
  const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
  const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
  const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(null);
  const [equipment, setEquipment] = useState<EquipmentDTO>({} as EquipmentDTO);
  const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
  const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(null);


  //ModeloCheckList
  const [isActiveAssistanceCheckListModule, setIsActiveAssistanceCheckListModule] = useState<boolean>(false);
  const [checklistModels, setChecklistModels] = useState<{ id: string; name: string }[]>([]);
  const [isLoadingChecklistModels, setIsLoadingChecklistModels] = useState<boolean>(false);
  const [selectedChecklistModel, setSelectedChecklistModel] = useState<string>("");


  //obter tipo de assistencia
  const getAssistanceTypes = async () => {
    const list: SelectItemsProps[] = [];

    assistanceTypes.forEach((element) => {
      var item: SelectItemsProps = {
        value: element,
        label: element,
      };
      list.push(item);
    });

    setAssistanceTypesComponent(list);
  };

  //obter prioridades da assistência
  const getPriorities = async () => {
    const list: SelectItemsProps[] = [];
    const priorityList: number[] = [1, 2, 3];

    priorityList.forEach((priority) => {
      const item: SelectItemsProps = {
        value: priority.toString(),
        label: priority.toString(),
      };
      list.push(item);
    });


    setAssistancePriority(list);
  };
  useEffect(() => {
    getPriorities();
  }, []);



  //modulos ativos
  useEffect(() => {
    if (availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
      setIsActiveProjectModule(true);
    }
    if (availableModules.includes("FabricationSage50cIsActiveFabricationModule")) {
      setIsActiveFabricationModule(true);
    }
    if (availableModules.includes("ProfitabilitySage50cIsActiveProfitabilityModule")) {
      setIsActiveProfitabilityModule(true);
    }
    if (availableModules.includes("IsActiveCountersModule")) {
      setIsActiveCountersModule(true);
    }
    if (availableModules.includes("IsActiveCarPlate")) {
      setIsActiveCarPlate(true);
    }
    if (availableModules.includes("IsActivePriorityModule")) {
      setIsActivePriorityModule(true);
    }
    if (availableModules.includes("IsActiveErpSupportModule")) {
      setIsActiveErpSupportModule(true);
    }
    if (availableModules.includes("IsActiveAssistanceCheckListModule")) {
      setIsActiveAssistanceCheckListModule(true);
    }
  }, [availableModules]);

  // criar assistencia
  const createAssistance = async () => {
    // Combine date and time into a single Date object
    const combinedDateTime = new Date(`${assistanceDate}T${assistanceTime}`);

    var sendData: CreateAssistanceDTO = {
      id: assistance.id,
      date: combinedDateTime,
      description: assistance.description,
      notes: assistance.notes,
      equipmentErpId: equipment.erpId != undefined ? equipment.erpId : "",
      equipmentName: equipment.name != undefined ? equipment.name : null,
      equipmentCarPlate: equipment.carPlate != undefined ? equipment.carPlate : null,
      equipmentNumSerie: equipment.serialNumber != undefined ? equipment.serialNumber : null,
      equipmentBrand: equipment.brand != undefined ? equipment.brand : null,
      equipmentModel: equipment.model != undefined ? equipment.model : null,
      projectErpId: project.erpId != undefined ? project.erpId : "",
      clientErpId: equipment?.client?.erpId ?? clientSelected?.value ?? null,
      typeDoc: "FO",
      numDoc: null,
      serie: null,
      clientId: null,
      counter1: Number(timeHistory.counter1) || 0,
      unit1: timeHistory.unit1,
      counter2: Number(timeHistory.counter2) || 0,
      unit2: timeHistory.unit2,
      counter3: Number(timeHistory.counter3) || 0,
      unit3: timeHistory.unit3,
      assistanceType: selectedAssistanceType || "Reparação",
      stockEntryDocumentErpId: null,
      budgetSellingPrice: assistance.budgetSellingPrice,
      budgetCostPrice: assistance.budgetCostPrice,
      priority: Number(selectedAssistancePriority),
      workshopInternalNumber: assistance.workshopInternalNumber
    };

    var responseValidate = CreateAssistanceDTOSchema.validate(sendData, {
      allowUnknown: true,
    });

    if (responseValidate.error != null) {
      var message = responseValidate.error!.message;
      Toast.Show("error", message);
      return false;
    }

    // Verificar se o módulo da fabricação está visível e o campo "Tipo de Assistência" está vazio
    if (isActiveFabricationModule && !selectedAssistanceType) {
      Toast.Show("error", "Selecione o campo 'Tipo de Assistência'.");
      return false;
    }

    setIsButtonCreateLoading(true);
    var response = await assistanceService.CreateInDbAndErp(sendData);
    setIsButtonCreateLoading(false);

    if (response.success === false || response.obj === null) {
      Toast.Show("error", response.message);
      return;
    }
    Toast.Show("success", response.message);

    if (isActiveAssistanceCheckListModule) {
      const checklistResponse = await assistanceCheckListService.Create({
        assistanceId: response.obj,
        checkListModelId: selectedChecklistModel !== "" ? parseInt(selectedChecklistModel) : null,
      });
    }


    navigate(`${Routes.backoffice.details}/${response.obj}`);
  };

  useEffect(() => {
    getAssistanceTypes();
  }, []);

  //OBRAS
  //método Obra
  const GetProject = async (
    value: string
  ): Promise<SelectItemsProps[]> => {
    var data: SearchByProject = {
      project: value,
    };

    var response = await projectService.GetByProject(data);
    if (response.success === false || response.obj === null) {
      Toast.Show("error", response.message);
      return [];
    }

    const list: SelectItemsProps[] = [];

    response.obj.forEach((element) => {
      var item: SelectItemsProps = {
        value: element.erpId,
        label: element.description,
      };
      list.push(item);
    });

    return list;
  };

  const handleProjectChange = async (projectInput: any) => {

    if (projectInput == null) {
      setProjectSelected(null);
      return;
    }
    var data: SearchByProject = {
      project: projectInput.label,
    };

    const response = await projectService.GetByProject(data);

    if (response.success === false || response.obj === null) {
      Toast.Show("error", response.message);
      setIsSearchProjectLoading(false);
      return [];
    }
    setProject(response.obj[0]);
    setIsSearchProjectLoading(false);

    setProjectSelected({
      value: response.obj[0].erpId,
      label: response.obj[0].description
    })
    setClientSelected({
      value: response.obj[0].client.erpId,
      label: response.obj[0].client.name,
    })
  }

  //#region codigo relevante para criar nova assistência através de navegação do cliente
  const location = useLocation();
  useEffect(() => {
    if (location.state) {
      const { clientErpId, clientName } = location.state;
      if (clientErpId && clientName) {
        setClientSelected({ value: clientErpId, label: clientName });
      }
    }
  }, [location.state]);
  //#endregion

  //método para obter os modelos de checklist
  useEffect(() => {
    if (!isActiveAssistanceCheckListModule) return;   // único bloqueio real

    const fetchChecklistModels = async () => {
      setIsLoadingChecklistModels(true);

      try {
        // monta filtros só se existirem valores
        const parameters: Parameter[] = [];
        if (equipment.model) parameters.push(new Parameter("model", equipment.model));
        if (equipment.brand) parameters.push(new Parameter("brand", equipment.brand));

        const response = await assistanceCheckListService.GetAll(
          parameters,           // filtros (pode ficar [])
          [],                   // sem ordenação
          1,                    // página 1
          100                   // pageSize arbitrário
        );

        if (response.success && response.obj) {
          const models = response.obj.map((m: any) => ({
            id: m.id.toString(),
            name: m.title,      // << usa o campo que o backend devolve
          }));
          setChecklistModels(models);

          // se a checklist actualmente seleccionada não existe no novo resultado, limpa‑a
          if (!models.some((m) => m.id === selectedChecklistModel)) {
            setSelectedChecklistModel("");
          }
        } else {
          Toast.Show("error", response.message || "Erro ao obter modelos de checklist.");
          setChecklistModels([]);
          setSelectedChecklistModel("");
        }
      } catch {
        Toast.Show("error", "Erro inesperado ao obter modelos de checklist.");
        setChecklistModels([]);
        setSelectedChecklistModel("");
      } finally {
        setIsLoadingChecklistModels(false);
      }
    };

    fetchChecklistModels();

    // *toda* vez que muda modelo ou marca do equipamento, actualiza‑se
  }, [isActiveAssistanceCheckListModule, equipment.model, equipment.brand]);


  return (
    <>
      <label style={{ margin: "0px", padding: "13px" }}>
        <b>Informação Geral</b>
      </label>
      <Col xl={6}>
        <Row
          style={{
            margin: "0px",
            padding: "0px",
            alignItems: "flex-end",
            alignContent: "flex-end",
          }}
        >
          <SelectComponent
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ width: "100%", height: "43px" }}
            label={"Tipo de Assistência"}
            selectedItemValue={selectedAssistanceType}
            items={assistanceTypesComponent}
            onChange={(t: string) => {
              setSelectedAssistanceType(t);
            }}
          />
        </Row>

        {isActiveProjectModule && (
          <Row
            style={{
              margin: "0px",
              padding: "0px",
              alignItems: "flex-end",
              alignContent: "flex-end",
            }}
          >
            {/* Mostrar componentes quando projectModuleValue for verdadeiro */}
            <SearchSelectComponent
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              label={"Nome Obra"}
              loadOptions={GetProject}
              onChange={(e) => handleProjectChange(e)}
              value={projectSelected}
              style={{ width: "100%" }}
            />
          </Row>

        )}

        <Row
          style={{
            margin: "0px",
            padding: "0px",
            alignItems: "flex-end",
            alignContent: "flex-end",
          }}
        >

          <ClientEquipmentBidirecional
            isActiveProjectModule={isActiveProjectModule}
            projectSelected={projectSelected}
            clientSelected={clientSelected}
            setClientSelected={setClientSelected}
            serialNumberSelected={serialNumberSelected}
            setSerialNumberSelected={setSerialNumberSelected}
            equipment={equipment}
            setEquipment={setEquipment}
            isSearchEquipmentLoading={isSearchEquipmentLoading}
            setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}
            isActiveSearchByCarPlate={isActiveCarPlate}
            carPlateSelected={carPlateSelected}
            setCarPlateSelected={setCarPlateSelected}
            disableSoftwareFields={true}
            setAssistance={setAssistance}
            assistance={assistance}
          />
        </Row>

        {isActiveAssistanceCheckListModule && (
          <Row
            style={{
              margin: "0px",
              padding: "0px",
              alignItems: "flex-end",
              alignContent: "flex-end",
            }}
          >
            <SelectComponent
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={12} // Em telas pequenas, mantém responsivo
              style={{ height: "43px" }} // Removido width: "100%"
              label={"Modelo de Checklist"}
              selectedItemValue={
                checklistModels.length === 0 ? "" : selectedChecklistModel
              }
              items={
                checklistModels.length === 0
                  ? [{ value: "", label: "Sem modelos disponíveis" }]
                  : checklistModels.map((model) => ({
                    value: model.id,
                    label: model.name,
                  }))
              }
              onChange={(t: string) => setSelectedChecklistModel(t)}
              loading={isLoadingChecklistModels}
            />
          </Row>
        )}


        <Row
          style={{
            margin: "0px",
            padding: "0px",
            alignItems: "flex-end",
            alignContent: "flex-end",
          }}
        >
          <InputComponent
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            style={{ width: "100%" }}
            type={"date"}
            value={assistanceDate}
            label={"Dia"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistanceDate(t);
            }}
          />

          <InputComponent
            xl={4}
            lg={4}
            md={4}
            sm={4}
            xs={12}
            style={{ width: "100%" }}
            type={"time"}
            value={assistanceTime}
            label={"Hora"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistanceTime(t);
            }}
          />
        </Row>

        {/* Estado 2 - Contadores */}
        {isActiveCountersModule && !isActiveErpSupportModule && (
          <>
            <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
              {intl.formatMessage({ id: "Screens.AssistanceCreateB.CountersTitle" })}
            </label>
            <Row style={{ margin: "0px", padding: "0px" }}>
              {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory)}
            </Row>
          </>
        )}

        {isActiveProfitabilityModule && (
          <>
            {/* Mostrar componentes quando profitabilityModuleValue for verdadeiro */}
            <Row style={{ margin: "0px", padding: "0px" }}>
              <InputComponent
                xl={4}
                lg={4}
                md={4}
                sm={4}
                xs={4}
                style={{ width: "100%" }}
                type={"number"}
                value={assistance?.budgetSellingPrice || 0}
                label={"Orçamento Venda S/ IVA"}
                readOnly={false}
                onChange={(t: number) => {
                  setAssistance({ ...assistance, budgetSellingPrice: t });
                }}
              />
              <InputComponent
                xl={4}
                lg={4}
                md={4}
                sm={4}
                xs={4}
                style={{ width: "100%" }}
                type={"number"}
                value={assistance?.budgetCostPrice || 0}
                label={"Orçamento Custo S/ IVA"}
                readOnly={false}
                onChange={(t: number) => {
                  setAssistance({ ...assistance, budgetCostPrice: t });
                }}
              />
            </Row>
          </>
        )}

        {/* Estado 3 - Descrições */}
        <Row style={{ margin: "0px", padding: "0px" }}>
          <InputComponent
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ width: "100%" }}
            type={"textArea"}
            value={assistance?.description}
            label={"Descrição do Serviço"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistance({ ...assistance, description: t });
            }}
          />
        </Row>

        {isActivePriorityModule &&
          <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
            <SelectComponent
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ width: "100%", height: "43px" }}
              label={"Prioridade"}
              selectedItemValue={(selectedAssistancePriority === null || selectedAssistancePriority === "" || selectedAssistancePriority === undefined) ? assistance.priority?.toString() ?? "" : selectedAssistancePriority}
              items={assistancePriority}
              onChange={(t: string) => {
                setSelectedAssistancePriority(t);
              }}
            />
          </Row>
        }

        <Row style={{ margin: "0px", padding: "0px" }}>
          <InputComponent
            xl={12}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{ width: "100%" }}
            type={"textArea"}
            value={assistance?.notes}
            label={"Observações"}
            readOnly={false}
            onChange={(t: string) => {
              setAssistance({ ...assistance, notes: t });
            }}
          />
        </Row>
        <Row style={{ margin: "0px", padding: "0px" }}>
          <Col xl={1} lg={1} md={1} sm={1} xs={1}>
            <ButtonComponent
              loading={isButtonCreateLoading || isSearchProjectLoading}
              style={{ width: "100%", marginTop: "10px" }}
              text={intl.formatMessage({ id: "AssistanceCreateA.Save" })}
              onClick={() => createAssistance()}
            />
          </Col>
        </Row>
      </Col>
    </>
  );
}
